import * as yup from 'yup';

export const addressSchema = yup.object({
  address: yup.string().required('Address is required'),
  suburb: yup.string().required('Suburb is required'),
  state: yup.string().required('State is required'),
  postcode: yup.string().required('Postcode is required'),
});

export const createPropertySchema = yup.object({
  address: addressSchema,
});

export const editPropertySchema = yup.object({
  address: addressSchema,
  origin: yup.string().optional(),
});
